import {
  SELECT_MODAL_LIST,
  SELECT_MODAL_LIST_SUCCESS,
  SELECT_MODAL_LIST_ERROR,
  SELECT_MODAL_SELECTED,
  SELECT_MODAL_SELECTED_SUCCESS,
  SELECT_MODAL_SELECTED_ERROR,
  SELECT_MODAL_UPDATE,
  SELECT_MODAL_UPDATE_SUCCESS,
  SELECT_MODAL_UPDATE_ERROR,
} from "./actionTypes"


export const selectModalList = data => ({
  type: SELECT_MODAL_LIST,
  payload: data
});

export const selectModalListSuccess = data => ({
  type: SELECT_MODAL_LIST_SUCCESS,
  payload: {data}
});

export const selectModalListError = error => ({
  type: SELECT_MODAL_LIST_ERROR,
  payload: error,
});

export const selectModalSelected = data => ({
  type: SELECT_MODAL_SELECTED,
  payload: data
});

export const selectModalSelectedSuccess = data => ({
  type: SELECT_MODAL_SELECTED_SUCCESS,
  payload: {data}
});

export const selectModalSelectedError = error => ({
  type: SELECT_MODAL_SELECTED_ERROR,
  payload: error,
});

export const selectModalUpdate = data => ({
  type: SELECT_MODAL_UPDATE,
  payload: data
});

export const selectModalUpdateSuccess = data => ({
  type: SELECT_MODAL_UPDATE_SUCCESS,
  payload: {data}
});

export const selectModalUpdateError = error => ({
  type: SELECT_MODAL_UPDATE_ERROR,
  payload: error,
});